import { Immutable } from "immer";
import React from "react";

import { getDocument, getWindow } from "@thelabnyc/thelabui/src/utils/dom";

// Subset of the google platform.js API surface needed here.
type IGapi = {
    load: (name: string, cb: () => void) => void;
    surveyoptin?: {
        render: (opts: object) => void;
    };
};

type IProps = Immutable<{
    surveyData: string;
}>;

// Render the Google Seller Ratings survey opt-in widget by injecting the
// platform.js loader imperatively from useEffect (post-hydration). A positional
// React <script> vnode would collide with GTM-injected foreign body scripts
// and trip a hydration mismatch under React 19 full-document rendering.
// surveyData is a JSON string produced by ga_seller; empty string = DNT or no
// order, in which case we skip entirely.
export const GASeller = (props: IProps): React.ReactNode => {
    React.useEffect(() => {
        if (!props.surveyData) return;
        const win = getWindow() as
            | (Window & {
                  renderOptIn?: () => void;
                  gapi?: IGapi;
              })
            | null;
        const doc = getDocument();
        if (!win || !doc) return;
        win.renderOptIn = function () {
            win.gapi?.load("surveyoptin", function () {
                win.gapi?.surveyoptin?.render(
                    JSON.parse(props.surveyData) as object,
                );
            });
        };
        const script = doc.createElement("script");
        script.src =
            "https://apis.google.com/js/platform.js?onload=renderOptIn";
        script.async = true;
        script.defer = true;
        doc.body.appendChild(script);
    }, []);
    return null;
};
